import React, { Component } from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";

import {
  Container,
  Header,
  Left,
  Title,
  Content,
  AdressLineContainer,
  AdressLine,
  AdressItem,
  AdressName,
  AdressIcon,
  AdressNameContainer,
  AdressInfoContainer,
  Select,
  Hr,
  CloseIcon,
  AddressList
} from "./styles";
import api from "../../../../services/api";
import Loading from "../../../layout/loading";
import { handleUserId } from "../../../../store/actions/user-actions";

class Endereco extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      adresses: [],
      bases: []
    };
  }

  async componentDidMount() {
    const token = localStorage.getItem("@UltragazEmpresarial:accessToken");
    const login = localStorage.getItem("@UltragazEmpresarial:loginEmail");
    this.requestGetUserInfos(token, login);
  }

  requestGetUserInfos = (token, login) => {
    if (login) {
      const header = {
        "Content-Type": "application/json"
      };
      const parameters = {
        method: "GET",
        headers: header
      };
      api
        .get(
          `industrial/customer/v1/users/?login=${login}&is-active=true`,
          parameters
        )
        .then(res => {
          const response = res.data[0];
          const userId = response.userId;
          this.props.dispatch(handleUserId(response.userId));
          this.requestGetInstallbases(token, userId);
        })
        .catch(err => {
          this.setState({ loading: false });
          const erro = err.response;
          if (erro) {
            const message = err.response.data.message;
            if (err.response.status !== 401) {
              toast.error(message);
            }
          } else {
            if (err.response.status !== 401) {
              toast.error("Ocorreu um erro interno na aplicação");
            }
          }
        });
    }
  };

  requestGetInstallbases = (token, userId) => {
    const header = {
      "Content-Type": "application/json",
      access_token: token
    };
    const parameters = {
      method: "GET",
      headers: header
    };
    api
      .get(
        `industrial/customer/v1/users/${userId}/customers?&_offset=0&address_type=SHIP_TO`,
        parameters
      )
      .then(res => {
        const response = res.data;
        let adresses = [];
        response.map(address => {
          address.customerAddress.map(base => {
            adresses = [...adresses, { base, address }];
          });
        });
        this.setState({ adresses, loading: false });
      })
      .catch(err => {
        const erro = err.response;
        if (erro) {
          const message = err.response.data.message;
          if (err.response.status !== 401) {
            toast.error(message);
          }
        } else {
          if (err.response.status !== 401) {
            toast.error("Ocorreu um erro interno na aplicação");
          }
        }
      });
  };

  changeProfile = (
    code,
    siteId,
    customerCode,
    customerId,
    customerName,
    addressLine,
    userCustomerRelationshipId
  ) => {
    if (this.state.adresses.length > 1) {
      this.setState({ loading: true });
      const token = localStorage.getItem("@UltragazEmpresarial:accessToken");
      const username = localStorage.getItem("@UltragazEmpresarial:loginEmail");
      const header = {
        "Content-Type": "application/json",
        access_token: token
      };
      const parameters = {
        method: "POST",
        headers: header
      };
      const body = {
        userCustomerRelationshipId,
        username
      };
      api
        .post("industrial/customer/v1/users/change-profile", body, parameters)
        .then(res => {
          const response = res.data;
          localStorage.setItem(
            "@UltragazEmpresarial:accessToken",
            response.access_token
          );
          localStorage.setItem(
            "@UltragazEmpresarial:accessToken",
            response.access_token
          );
          this.handleSelectAddress(
            code,
            siteId,
            customerCode,
            customerId,
            customerName,
            addressLine,
            userCustomerRelationshipId
          );
        })
        .catch(err => {
          this.setState({ loading: false });
          const erro = err.response;
          if (erro) {
            const message = err.response.data.message;
            toast.error(message);
          }
        });
    } else {
      this.handleSelectAddress(
        code,
        siteId,
        customerCode,
        customerId,
        customerName,
        addressLine,
        userCustomerRelationshipId
      );
    }
  };

  handleSelectAddress = (
    code,
    siteId,
    customerCode,
    customerId,
    customerName,
    addressLine,
    userCustomerRelationshipId
  ) => {
    localStorage.setItem("@UltragazEmpresarial:customerSiteCode", code);
    localStorage.setItem("@UltragazEmpresarial:customerSiteId", siteId);
    localStorage.setItem("@UltragazEmpresarial:customerCode", customerCode);
    localStorage.setItem("@UltragazEmpresarial:customerId", customerId);
    localStorage.setItem("@UltragazEmpresarial:customerName", customerName);
    localStorage.setItem(
      "@UltragazEmpresarial:customerAddressLine",
      addressLine
    );
    localStorage.setItem(
      "@UltragazEmpresarial:userCustomerRelationshipId",
      userCustomerRelationshipId
    );
    this.setState({ selectedAdress: code });
    window.location.reload();
  };

  render() {
    const { adresses, loading } = this.state;
    const { close } = this.props;
    const selectedAdress = localStorage.getItem(
      "@UltragazEmpresarial:customerSiteCode"
    );
    return (
      <>
        {loading ? (
          <Loading />
        ) : (
          <Container>
            <Header>
              <Left>
                <Title>Selecione um Endereço</Title>
              </Left>
              <CloseIcon
                onClick={close}
                title="Fechar"
                className="mdi mdi-close"
              />
            </Header>
            <Content>
              Encontramos os seguintes endereços vinculados a sua conta:
            </Content>
            <AddressList>
              {adresses.map(item => {
                const { base, address } = item;
                return (
                  <>
                    <AdressItem
                      onClick={() =>
                        this.changeProfile(
                          base.code,
                          base.siteId,
                          address.customerCode,
                          address.customerId,
                          address.name,
                          base.addressLine,
                          address.userCustomerRelationshipId
                        )
                      }
                      key={base.code}
                      id={base.code}
                      name={base.code}
                    >
                      <Select
                        type="radio"
                        id={base.code}
                        name={base.code}
                        checked={selectedAdress === base.code ? true : false}
                      />
                      <AdressInfoContainer>
                        <AdressNameContainer>
                          <AdressIcon className="mdi mdi-map-marker" />
                          <AdressName>{address.name}</AdressName>
                        </AdressNameContainer>
                        <AdressLineContainer>
                          <AdressLine>
                            {base.addressLine}, {base.addressNumber} -{" "}
                            {base.city} {base.stateCode}
                          </AdressLine>
                        </AdressLineContainer>
                      </AdressInfoContainer>
                    </AdressItem>
                    {adresses.length === 1 ? null : <Hr />}
                  </>
                );
              })}
            </AddressList>
          </Container>
        )}
      </>
    );
  }
}

const mapStateToProps = state => ({
  customerAddresses: state.userReducer.customerAddresses,
  userId: state.userReducer.userId
});

export default connect(mapStateToProps)(Endereco);
